import '../scss/components/_ownerreports.scss'
import React from 'react'

const OwnerComplianceReport = () => {
  return (
    <div className="rpt-coming-soon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#D1D5DB" strokeWidth="1.4">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M9 9h6M9 12h6M9 15h4" />
      </svg>
      <p className="rpt-coming-title">Compliance Report coming soon</p>
      <p className="rpt-coming-sub">This report will appear here once connected to its data source.</p>
    </div>
  )
}

export default OwnerComplianceReport